module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-white"
  }, [_c('div', {
    staticClass: "section-box view-flex view-flex-vertical view-flex-center view-flex-middle"
  }, [_c('div', {
    staticClass: "slogn"
  }, [_c('div', {
    staticClass: "logo-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoIcon,
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.companyBrand == '超新星') ? _c('div', [_c('h3', [_vm._v("超新星因你而更好")])]) : _vm._e()]), _vm._v(" "), (_vm.loginType != 'distributor') ? _c('div', {
    staticClass: "content-center"
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入激活码"
    },
    model: {
      value: (_vm.active_code),
      callback: function($$v) {
        _vm.active_code = $$v
      },
      expression: "active_code"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("购买或续费产品请联系：400-9213-522    QQ: 800058282")])], 1) : _vm._e(), _vm._v(" "), (_vm.loginType == 'distributor') ? _c('div', {
    staticClass: "content-center"
  }, [_c('p', {
    staticClass: "desc"
  }, [_vm._v("您的授权已过期，请联系平台管理员处理授权")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "active-opr"
  }, [(_vm.loginType != 'distributor') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.activetionAction
    }
  }, [_vm._v("激活")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("返回登录")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "before-close": _vm.closeDialog
    }
  }, [_c('div', {
    staticClass: "brand"
  }, [_c('div', {
    staticClass: "logo-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoIcon,
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.resultTxt))])]), _vm._v(" "), _c('p', {
    staticClass: "frm-tips content-center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("此资源包到期时间为  "), _c('span', [_vm._v(_vm._s(_vm._f("datetime")(_vm.expired_at, 'yyyy-MM-dd hh:mm:ss')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center active-opr",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v(_vm._s(_vm.btnTxt))])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75ebbb5c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75ebbb5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/asset/accountactivation/index.vue
// module id = 2834
// module chunks = 0